import overlay from './loader';

$('body').on('click', '.change-personal-store', function (e) {
    e.preventDefault();
    const storeIdentifier = $(this).data('identifier');
    overlay(true);
    window.axios.put(window.config.urls.stores.changePersonalStore, {
        store: storeIdentifier
    }).then(() => {
        location.reload();
    });
});
